export const parseFonepayQR = (qr: string) => {
  let i = 0;
  const result: any = {};

  while (i < qr.length) {
    const id = qr.slice(i, i + 2);
    const length = parseInt(qr.slice(i + 2, i + 4), 10);
    const value = qr.slice(i + 4, i + 4 + length);

    if (id === "59") {
      result.companyName = value;
    }

    if (id === "60") {
      result.address = value;
    }

    if (id === "26") {
      const accMatch = value.match(/0716(\d{16})/);
      if (accMatch) {
        result.accountNumber = accMatch[1];
      }
    }

    i += 4 + length;
  }

  return result;
};
